import React, { lazy, Suspense, useMemo } from "react";
import { useAppSelector } from "../../store/hooks";
import { OperateSelectorProps } from "./types";
import OperateSection from "./ui/OperateSection/OperateSection";
import ReviewModal from "./ui/ReviewModal/ReviewSection";
import OperateSectionMobile from "./ui/OperateSectionMobile/OperateSectionMobile";

const OrderDetailsModal = lazy(
  () => import("./ui/OrderDetailsModal/OrderDetailsModal"),
);
const SummaryModal = lazy(() => import("./ui/SummaryModal/SummaryModal"));

const OperateSelectorMEP: React.FC<OperateSelectorProps> = React.memo(
  ({
    values,
    setFieldValue,
    mepPrice,
    errors,
    isValid,
    availableArs,
    availableMep,
    handleSubmit,
    handleClose,
    accountOptions,
    handleAccountChange,
    resetForm,
    setValues,
    isMobile,
    refetchPositions,
    symbolPositionLoading,
    mepPriceToShow,
  }) => {
    const { operationState } = useAppSelector(
      (state) => state.operationMEPData,
    );

    const operateSection = useMemo(() => {
      return isMobile ? (
        <OperateSectionMobile
          values={values}
          setFieldValue={setFieldValue}
          mepPrice={mepPrice}
          errors={errors}
          isValid={isValid}
          availableArs={availableArs}
          availableMep={availableMep}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
          accountOptions={accountOptions}
          handleAccountChange={handleAccountChange}
          setValues={setValues}
          symbolPositionLoading={symbolPositionLoading}
          mepPriceToShow={mepPriceToShow}
        />
      ) : (
        <OperateSection
          values={values}
          setFieldValue={setFieldValue}
          mepPrice={mepPrice}
          errors={errors}
          isValid={isValid}
          availableArs={availableArs}
          availableMep={availableMep}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
          accountOptions={accountOptions}
          handleAccountChange={handleAccountChange}
          setValues={setValues}
          symbolPositionLoading={symbolPositionLoading}
          mepPriceToShow={mepPriceToShow}
        />
      );
    }, [
      isMobile,
      values,
      setFieldValue,
      mepPrice,
      errors,
      isValid,
      availableArs,
      availableMep,
      handleSubmit,
      handleClose,
      accountOptions,
      handleAccountChange,
      setValues,
    ]);

    switch (operationState) {
      case "DRAFT":
        return operateSection;
      case "REVIEW":
        return (
          <ReviewModal
            resetForm={resetForm}
            setFieldValue={setFieldValue}
            acceptedTermsAndConditions={values.acceptedTermsAndConditions}
            mepQuote={mepPrice}
            handleClose={handleClose}
            refetchPositions={refetchPositions}
          />
        );

      case "SUMMARY":
        return (
          <Suspense fallback={null}>
            <SummaryModal />
          </Suspense>
        );

      case "DETAILS":
        return (
          <Suspense fallback={null}>
            <OrderDetailsModal resetForm={resetForm} />
          </Suspense>
        );

      default:
        return operateSection;
    }
  },
);

export default OperateSelectorMEP;
